import { ASSETS } from "@/lib/assets";

export const Footer = () => (
  <footer className="relative border-t border-[#242424] py-16 md:py-20" data-testid="footer">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
        <div className="flex items-center gap-4">
          <img src={ASSETS.schnauzerDog} alt="Silver Schnauzer Studios" loading="lazy" decoding="async" className="h-16 w-12 object-contain" />
          <div className="text-center">
            <p className="font-display text-2xl tracking-tight leading-none">
              Silver Schnauzer
              <sup className="font-mono-accent text-[0.42em] tracking-normal ml-0.5 -top-[0.9em]">®</sup>
            </p>
            <p className="font-mono-accent text-[10px] tracking-[0.35em] text-[#8b8b8b] mt-1">STUDIOS</p>
          </div>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-[#1c1c1c] flex flex-col sm:flex-row justify-between gap-4">
        <p className="font-mono-accent text-[10px] tracking-[0.15em] text-[#6a6a6a]">
          © {new Date().getFullYear()} SILVER SCHNAUZER STUDIOS. ALL RIGHTS RESERVED.
        </p>
        <p className="font-mono-accent text-[10px] tracking-[0.15em] text-[#6a6a6a]">
          SOFTWARE · DESIGN · BRAND
        </p>
      </div>
    </div>
  </footer>
);
